import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export default {
  drawer: css`
    position: fixed;
    top: 0;
    height: 100dvh;
    ${MQ.NOT_PHONES} {
      width: 45vw;
    }
    ${MQ.TABLETS} {
      width: 100dvw;
    }
    ${MQ.PHONES} {
      width: 100dvw;
    }
    display: flex;
    flex-direction: column;
    padding: ${spacing(5)};
    ${MQ.PHONES} {
      padding: ${spacing(1)};
    }
    z-index: 5;
    background-color: ${colors.grays.gray8};
    box-sizing: border-box;
    transition: right 0.5s ease-in-out;
    overflow-y: auto;
    overflow-x: hidden;
  `,
  drawerActive: css`
    right: 0;
  `,
  drawerDisabled: css`
    display: none;
  `,
  closeButton: css`
    position: absolute;
    top: ${spacing(5)};
    right: ${spacing(5)};
    padding: ${spacing(0.5)};
    color: ${colors.white100};
    cursor: pointer;
  `,
  overlay: css`
    position: fixed;
    left: 0;
    top: 0;
    width: 100dvw;
    height: 100dvh;
    transition: opacity 0.5s ease-in-out;
    background-color: ${colors.black100};
    z-index: 4;
  `,
  overlayActive: css`
    opacity: 0.6;
  `,
  overlayDisabled: css`
    opacity: 0;
    z-index: -123123;
  `,
}
